import Vue from 'vue'
import api from '../../api/api'

const department = {
  state: {
    list: [],
    page: {}
  },

  mutations: {
    SET_DEPARTMENT_LIST(state, data) {
      state.list = data || []
    }
  },

  actions: {
    async getDepartmentList({ commit, rootState}) {
      let params = Object.assign({},rootState.route.query)
      let ret = await api.getDepartment(params)
      commit('SET_DEPARTMENT_LIST', ret.data)
      console.log('部门列表', ret)
    }
  }
};

export default department


// WEBPACK FOOTER //
// ./src/store/modules/department.js